import { repository, adminURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(adminURL + '/admin/user/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(adminURL + '/admin/user', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(adminURL + '/admin/user', body)
    return data
  },

  async remove(id) {
    return await repository.delete(adminURL + '/admin/user/' + id)
  }
}
